import { LitElement, html, css } from 'lit';
import { validateForm } from '../../utilities/formsUtilities';
import { accessibility, formStyles } from '../../utilities/styles';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInAcceptInvite extends LitElement {
    static properties = {
        nonce: { type: String },
        action: { type: String },
        successRedirect: { type: String },
        orgid: { type: String },
        email: { type: String },
        invite: { type: String },
        user: { type: String },
    };
    constructor() {
        super();
    }
    async connectedCallback() {
        super.connectedCallback();
        try {
            await this.updateComplete;
            if (this.innerForm) {
                let email = this.innerForm.querySelectorAll('input[type="email"]');
                if (email.length) {
                    email.forEach((input, i) => {
                        input.value = this.email;
                        input.parentElement.style.display = 'none';
                        if (i == 0) {
                            let p = document.createElement('p');
                            p.innerText = this.email;
                            let p2 = document.createElement('p');
                            p2.innerHTML = `&lt;strong&gt;Dyma\u2019r cyfeiriad e-bost o\u2019ch gwahoddiad. Dyma fydd eich enw defnyddiwr hefyd&lt;/strong&gt;`;
                            let div = document.createElement('div');
                            div.classList.add('input-group');
                            div.append(p2);
                            div.append(p);
                            input.parentElement.insertAdjacentElement('afterend', div);
                        }
                    });
                }
                let hiddenInputs = ['invite', 'orgid'];
                hiddenInputs.forEach(name => {
                    let input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = name;
                    input.value = this[name];
                    this.innerForm.appendChild(input);
                });
            }
        }
        catch (e) {
            console.log(e);
        }
        ;
    }
    get form() {
        return this.shadowRoot.querySelector('form');
    }
    get formResponse() {
        return this.shadowRoot.querySelector('.message');
    }
    get submitButton() {
        return this.shadowRoot.querySelector('input[type="submit"]');
    }
    get innerForm() {
        if (this._slottedChildren.length === 0)
            return null;
        return this._slottedChildren[0].shadowRoot.querySelector('form');
    }
    get _slottedChildren() {
        const slot = this.renderRoot.querySelector('slot');
        if (!slot)
            return [];
        return slot.assignedElements({ flatten: true });
    }
    render() {
        let markup;
        if (this.user) {
            markup = html `\n            <form class="signup-form" @submit="${this._accept}">\n                <div class="field_group">\n                    <label for="jobtitle">Teitl swydd yn y sefydliad hwn*</label>\n                    <input type="text" name="jobtitle" id="jobtitle" aria-required>\n                </div>\n                <input type="hidden" name="invite" value="${this.invite}">\n                <input type="hidden" name="orgid" value="${this.orgid}">\n                <input type="hidden" name="email" value="${this.email}">\n                <input type="hidden" name="action" value="accept-invite">\n                <input type="submit" value="Derbyn y Gwahoddiad">\n                <div class="message"></div>\n            </form>`;
        }
        else {
            markup = html `\n            <slot></slot>\n            `;
        }
        return html ` \n            <div class="accept-invite">\n                ${markup}\n            </div>\n        `;
    }
    async _accept(e) {
        e.preventDefault();
        let valid = validateForm(this.form, this.formResponse);
        if (!valid)
            return;
        let formData = new FormData(this.form);
        formData = JSON.stringify(Object.fromEntries(formData));
        this.form.classList.add('loading');
        this.submitButton.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        try {
            let response = await fetch(this.action, {
                method: 'POST',
                body: formData,
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            response = await response.json();
            if (response.ok) {
                this.form.classList.remove('loading');
                this.form.setAttribute('aria-busy', 'false');
                window.location.href = this.successRedirect;
            }
            else {
                this.formResponse.innerHTML = response.error;
                this.form.classList.remove('loading');
                this.form.setAttribute('aria-busy', 'false');
                this.submitButton.disabled = false;
            }
        }
        catch (error) {
            console.error('Error:', error);
            this.formResponse.innerHTML = error.error ?? `Gwall. Rhowch gynnig arall arni eto, neu adnewyddu\u2019r dudalen. `;
            this.form.classList.remove('loading');
            this.form.setAttribute('aria-busy', 'false');
            this.submitButton.disabled = false;
        }
        ;
    }
    static styles = [
        accessibility,
        formStyles,
        css `
        .signup-form{
            width:680px;
            max-width:85vw;
            margin:0 auto;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .small{
            font-size:0.875rem;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }
        `
    ];
}
